function getCcyByISO(val) {
    let s = val;
    if(val === 'EUR') { s = '€' }
    else if(val === 'USD') { s = '$' }
    else if(val === 'GBP') { s = '£' }
    return s;
}

export { getCcyByISO }